import Icon, {
	type MaterialDesignIconsIconName,
} from "@react-native-vector-icons/material-design-icons/static";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export type ToolActionProps = {
	text: string;
	icon: MaterialDesignIconsIconName;
};

const ToolAction = ({ text, icon }: ToolActionProps) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			display="flex"
			alignSelf="flex-start"
			alignItems="center"
			paddingHorizontal={12}
			paddingVertical={6}
			backgroundColor={theme.colors.secondaryContainer}
			borderRadius={28}
		>
			<Icon name={icon} size={18} color={theme.colors.primary} />
			<Box marginLeft={8}>
				<Text
					variant="labelLarge"
					style={{ color: theme.colors.onSecondaryContainer }}
				>
					{text}
				</Text>
			</Box>
		</Box>
	);
};

export default ToolAction;
